import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import './HeroSection.css';
import gamerImage from '../../assets/hero-img.svg';

function HeroSection({ selectedCity }) {
  const cityLabel = selectedCity || 'Conselheiro Lafaiete';

  return (
    <section id="home" className="hero-section">
      <div className="fiber-lines" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="hero-content">
        <div className="hero-text">
          <span className="service-badge">Fibra óptica premium em {cityLabel}</span>
          <h1>Internet rápida, estável e pronta para sua rotina.</h1>
          <p>
            Planos de 400 Mega a Ilimitado com fibra óptica pura, baixa latência
            e suporte local para sua casa, seu trabalho e seus momentos de lazer.
          </p>

          <div className="hero-buttons">
            <ScrollLink
              to="plans"
              smooth={true}
              duration={500}
              offset={-80}
              className="btn-primary"
            >
              Ver planos
            </ScrollLink>
            <RouterLink to="/contact" className="btn-secondary">
              Consultar cobertura
            </RouterLink>
          </div>
        </div>

        <div className="hero-visual">
          <img src={gamerImage} alt="Pessoa usando internet de alta velocidade" />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
